import { Component } from '@angular/core';

@Component({
  selector: 'curbnturf-cards-accepted',
  templateUrl: './cards-accepted.component.html',
  styleUrls: ['./cards-accepted.component.scss'],
  standalone: true,
})
export class CardsAcceptedComponent {}
